'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import Script from 'next/script'
import { useEffect, useRef, Suspense } from 'react'

const FACEBOOK_PIXEL_ID = '826931646978104'

declare global {
  interface Window {
    fbq?: any
  }
}

export const trackMetaPixelCustom = (
  eventName: string,
  params?: Record<string, unknown>
) => {
  if (typeof window === 'undefined') return
  const payload = params ?? {}

  const trySend = () => {
    const fbq = window.fbq
    if (typeof fbq === 'function') {
      fbq('trackCustom', eventName, payload)
      return true
    }
    return false
  }

  if (trySend()) return

  const started = Date.now()
  const maxMs = 5000
  const timer = window.setInterval(() => {
    if (trySend() || Date.now() - started > maxMs) {
      window.clearInterval(timer)
    }
  }, 50)
}

const FacebookPixelPageViews = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isFirst = useRef(true)

  useEffect(() => {
    if (!pathname) return
    if (isFirst.current) {
      isFirst.current = false
      return
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView')
    }
  }, [pathname, searchParams])

  return null
}

export const FacebookPixel = () => {
  return (
    <>
      <Script
        id="fb-pixel-base"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${FACEBOOK_PIXEL_ID}');
            fbq('track', 'PageView');
          `,
        }}
      />
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
      <Suspense fallback={null}>
        <FacebookPixelPageViews />
      </Suspense>
    </>
  )
}
